import { t } from 'i18next'
import moment from 'moment'
import * as yup from 'yup'

export const SchemaLimitAdgustment = yup.object().shape({
  fromDate: yup
    .string()
    .required('businessCards.startDateEnter')
    .test(
      'is-valid-fromDate',
      'businessCards.startDateValidate',
      function (value) {
        if (!value) return true
        const today = moment().startOf('day')
        const start = moment(value, 'DD.MM.YYYY', true)
        return start.isSameOrAfter(today)
      }
    )
    .test(
      'is-not-equal-toDate',
      'businessCards.endAndStartDateSame',
      function (value) {
        const { toDate } = this.parent
        if (!toDate || !value) return true

        const start = moment(value, 'DD.MM.YYYY', true)
        const end = moment(toDate, 'DD.MM.YYYY', true)

        return !start.isSame(end, 'day')
      }
    ),
  toDate: yup
    .string()
    .required(t('businessCards.endDateEnter'))
    .test('is-valid-toDate', 'businessCards.endDateValidate', function (value) {
      if (!value) return true
      const today = moment().startOf('day')
      const end = moment(value, 'DD.MM.YYYY', true)
      return end.isSameOrAfter(today)
    })
    .test(
      'is-not-equal-fromDate',
      'businessCards.endAndStartDateSame',
      function (value) {
        const { fromDate } = this.parent
        if (!fromDate || !value) return true

        const start = moment(fromDate, 'DD.MM.YYYY', true)
        const end = moment(value, 'DD.MM.YYYY', true)

        return !start.isSame(end, 'day')
      }
    ),
  toExpDate: yup.boolean(),

  amount: yup
    .number()
    .typeError('')
    .required('')
    .max(99999, 'businessCards.maxFiveSymbols'),
  curr: yup.string(),
  status: yup.string(),
  count: yup
    .number()
    .typeError('')
    .required('')
    .max(99999, 'businessCards.maxFiveSymbols'),
  statusForLabel: yup.string(),
  pan: yup.string(),
  expDate: yup.string().optional(),
  limitType: yup.string(),
  cif: yup.string(),
})
